import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {concatLatestFrom} from '@ngrx/operators';
import {Store} from '@ngrx/store';
import {of} from 'rxjs';
import {catchError, filter, map, switchMap, tap} from 'rxjs/operators';
import {contextDataToProductQuery} from '../context-data';
import {selectContextData} from '../context-data/context-data.selectors';
import {CommerceError} from '../error-handling/commerce-error';
import {unrecoverableError} from '../error-handling/error-handling.actions';
import {
  loadCatalogsFailure,
  loadQualifyingCatalogIds,
  loadQualifyingCatalogIdsSuccess,
} from './catalog.actions';
import {loadAddon} from '../../add-ons/add-on.actions';
import {CatalogApiService} from '../../data/api/service/catalog-api.service';

@Injectable()
export class CatalogEffects {
  loadQualifyingCatalogIds$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadQualifyingCatalogIds),
      concatLatestFrom(() => this.store.select(selectContextData)),
      filter(([, context]) => !!context),
      switchMap(([, context]) => {
        const signup = context?.signups ? context.signups[0] : undefined;
        if (
          !context ||
          !signup ||
          !signup?.registration ||
          !signup?.registration?.id
        ) {
          const error = new Error('registration id not found');
          return of(loadCatalogsFailure({error}));
        }
        return this.catalogApi
          .getQualifyingCatalogIds(contextDataToProductQuery(context))
          .pipe(
            map(catalogIds => loadQualifyingCatalogIdsSuccess({catalogIds})),
            catchError((error: Error) => {
              return of(loadCatalogsFailure({error}));
            }),
          );
      }),
    );
  });

  loadQualifyingCatalogIdsSuccess$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(loadQualifyingCatalogIdsSuccess),
        tap(({catalogIds}) => {
          for (const catalogId of catalogIds) {
            this.store.dispatch(loadAddon({catalogId}));
          }
        }),
      );
    },
    {dispatch: false},
  );

  loadCatalogsFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadCatalogsFailure),
      map(action => {
        return unrecoverableError({
          error: new CommerceError(action.error.message, action.error.stack),
        });
      }),
    );
  });

  constructor(
    private actions$: Actions,
    private store: Store,
    private catalogApi: CatalogApiService,
  ) {}
}
